module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.dataLuggageCopy) ? _c('div', {}, [_c('div', {
    staticClass: "form_container"
  }, [_c('div', {
    staticClass: "suitCase-content"
  }, [_c('div', {
    staticClass: "formContent"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "formNew"
  }, [_c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modalSuitcase",
      modifiers: {
        "modalSuitcase": true
      }
    }],
    staticClass: "btn-primary"
  }, [_c('i', {
    staticClass: "fas fa-plus"
  }), _vm._v("Añadir equipaje\n            ")])], 1)]), _vm._v(" "), (_vm.dataLuggageCopy.luggage_items != null && _vm.dataLuggageCopy.luggage_items.length != 0) ? _c('div', {
    staticClass: "vitrinaContainer"
  }, [_c('div', {
    staticClass: "vitrina"
  }, [_c('ul', _vm._l((_vm.dataLuggageCopy.luggage_items), function(luggageItem) {
    return _c('li', [_c('cardAddLuggage', {
      attrs: {
        "dataLuggage": luggageItem
      },
      on: {
        "delete-from-luggage-list": _vm.deleteFromLuggageList
      }
    })], 1)
  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.dataLuggageCopy.luggage_items == null || _vm.dataLuggageCopy.luggage_items.length == 0) ? _c('div', {
    staticClass: "emptyVitrina"
  }, [_c('p', [_vm._v("No has añadido equipaje")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('div', {
    staticClass: "weightContent"
  }, [_c('span', [_vm._v(_vm._s(_vm._f("currency")(_vm.totalWeight)) + " kg")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-lg btn-edit",
    on: {
      "click": _vm.toNextForm
    }
  }, [_vm._v("Continuar")])])])]), _vm._v(" "), _c('b-modal', {
    ref: "modalSuitcase",
    attrs: {
      "hide-footer": "",
      "hide-header": "",
      "id": "modalSuitcase"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }, [_vm._v("Datos de equipaje")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideModalSuitcase
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "id": "modal-body"
    }
  }, [_c('div', {
    staticClass: "form-login text-title",
    attrs: {
      "id": "infoextra"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Tipo de equipaje")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.typeLuggage),
      expression: "typeLuggage"
    }],
    staticClass: "form-control form-control-lg",
    attrs: {
      "name": "type_luggage"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.typeLuggage = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Selecciona")]), _vm._v(" "), _vm._l((_vm.listLuggageType), function(luggageType) {
    return _c('option', {
      domProps: {
        "value": luggageType
      }
    }, [_vm._v(_vm._s(_vm.luggageTypeTitle[luggageType.attributes.key]))])
  })], 2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('type_luggage')),
      expression: "errors.has('type_luggage')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('type_luggage')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Peso"), _c('i', {
    staticClass: "far fa-question-circle",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "Tooltip"
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|decimal:2'),
      expression: "'required|decimal:2'"
    }, {
      name: "floatonly",
      rawName: "v-floatonly"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.weightLuggage),
      expression: "weightLuggage"
    }],
    staticClass: "form-control null",
    attrs: {
      "type": "text",
      "name": "weight_luggage",
      "maxlength": 8
    },
    domProps: {
      "value": (_vm.weightLuggage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.weightLuggage = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('weight_luggage')),
      expression: "errors.has('weight_luggage')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('weight_luggage')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Unidad de peso")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.weightUnitLuggage),
      expression: "weightUnitLuggage"
    }],
    staticClass: "form-control form-control-lg",
    attrs: {
      "name": "weight_unit"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.weightUnitLuggage = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Selecciona")]), _vm._v(" "), _vm._l((_vm.listWeightUnit), function(weughtUnit) {
    return _c('option', {
      domProps: {
        "value": weughtUnit
      }
    }, [_vm._v(_vm._s(weughtUnit.attributes.name))])
  })], 2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('weight_unit')),
      expression: "errors.has('weight_unit')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('weight_unit')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Descripción"), _c('i', {
    staticClass: "far fa-question-circle",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "Tooltip"
    }
  })]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.descriptionLuggage),
      expression: "descriptionLuggage"
    }],
    staticClass: "form-control null",
    attrs: {
      "name": "description_luggage",
      "rows": "3",
      "cols": "70",
      "maxlength": 500
    },
    domProps: {
      "value": (_vm.descriptionLuggage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.descriptionLuggage = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('description_luggage')),
      expression: "errors.has('description_luggage')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('description_luggage')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-right"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addNewLuggage
    }
  }, [_vm._v("Continuar")])])])])], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "formTitle"
  }, [_c('h1', [_vm._v("Equipaje")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55718ad3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/prefab/elements/form-2-create-shipment.vue
// module id = 1880
// module chunks = 1